<template>
  <div class="container">
    <!-- <p v-if="couponLimit" class="limitInfo">
      {{`${locale.service_disabled_create_coupon} ${locale.service_suggest_upgrade}`}}
    </p> -->
    <section id="editContent">
      <h1 class="contentTitle">{{locale.nav_coupon}}</h1>
      <CouponList
        :locale="locale"
        :list="couponList"
        @setDetail="setDetail" />
    </section>
    <Detail
      v-if="couponDetail"
      :locale="locale"
      @close="setDetail(false)" />
    <!-- <div id="setContent" @click="flagOn">
      <Preview v-if="preview" :locale="locale" />
      <SetCoupon
        :locale="locale"
        :couponLimit="couponLimit"
        :isActive="isActive"
        @hasActive="hasActive"
        @flagOff="flagOff" />
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CouponList from '@/components/Coupon/List'
import Detail from '@/components/Coupon/Detail'

export default {
  name: 'Coupon',
  components: {
    CouponList,
    Detail
  },
  props: [
    'locale'
  ],
  computed: {
    ...mapGetters({
      authInfo: 'authentication/getAuthInfo',
      coupons: 'coupon/coupon'
    }),
    couponList () {
      const coupons = this.coupons
      const sortBy = 'createat'
      let list = []
      function stringToArray (str) {
        return JSON.parse(str.replace(/'|"|\\/g, ''))
      }
      if (coupons.length) {
        list = coupons.sort(function (a, b) {
          return a[sortBy] > b[sortBy] ? -1 : a[sortBy] < b[sortBy] ? 1 : 0
        }).map(x => {
          return {
            ...x,
            category: stringToArray(x.category)
          }
        })
      }
      return list
    }
  },
  created () {
    if (this.$store.getters['authentication/getUserInfo'] !== null) {
      this.$store.commit('onLoading', true)
      this.$store.dispatch('coupon/getCouponList').then(() => {
        this.$store.commit('onLoading', false)
      })
    }
  },
  mounted () {
  },
  data () {
    return {
      couponDetail: null
    }
  },
  methods: {
    setDetail (isActive) {
      this.couponDetail = isActive
    }
  }

}
</script>

<style lang="scss" scoped>
.container #setContent {
  width: 400px;
  > div {
    width: auto;
  }
}
</style>
